import React from "react"
import {Wrapper} from "./styled"
import LetterPlacer from "./letterPlacer/LetterPlacer"

const LetterPanel = ({letters}) => (
  <Wrapper>
    {letters.map(letter=>(<LetterPlacer key={letter.id} />))}
  </Wrapper>
)

export default LetterPanel